import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import ViewPage from '../../../Components/ViewPage';

import {
  ROUTE_DESIGN_INSIGHTS,
  ROUTE_DESIGN_INSIGHTS_ACCURACY_OPTIMIZE,
} from '../../../Routes/routes';

const BREADCRUMBS = [{
  title: 'Design Insights',
  route: `/${ROUTE_DESIGN_INSIGHTS}`,
}, {
  title: 'Optimize',
  route: `/${ROUTE_DESIGN_INSIGHTS_ACCURACY_OPTIMIZE}`,
}];

function Optimize({
  toggleDrawer,
}) {
  return (
    <ViewPage title="Optimize" toggleDrawer={toggleDrawer} breadcrumbs={BREADCRUMBS}>
      <Box data-testid="Optimize-View-Container">
        <h1>Optimize</h1>
      </Box>
    </ViewPage>
  );
}

Optimize.propTypes = {
  toggleDrawer: PropTypes.func,
};

Optimize.defaultProps = {
  toggleDrawer: () => {
    // Default
  },
};

export default Optimize;
